// extracted by mini-css-extract-plugin
export var borderRadius = "_fm-4";
export var large = "_fm-3";
export var logoContainer = "_fm-0";
export var nameLogo = "_fm-2";
export var small = "_fm-1";